module.exports = __webpack_public_path__ + "img/logo_full.151c9519.png";